import React, { useCallback, useEffect, useState } from 'react';
import { sumBy } from 'lodash';

import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';
import { AdderVm } from '@/types/backend';
import { formatPriceWithCurrency } from '@/utils/format-price';

import { OrderBlock } from '../../../Common/OrderBlock';
import { OrderBlockWrapper } from '../../../Common/OrderBlockWrapper';

import { Props } from './types';

import styles from './AdderDetails.module.scss';

export const AdderDetails = ({ proposalAdders }: Props) => {
  const state = useOrderContext();
  const { isPriceHidden } = state;
  const [addersTotal, setAddersTotal] = useState<number>(
    sumBy(proposalAdders, adder => adder.unitPrice),
  );

  const getAdderPrice = useCallback((unitPrice: number, quantity: number) => {
    return unitPrice * quantity;
  }, []);

  useEffect(() => {
    setAddersTotal(sumBy(proposalAdders, adder => getAdderPrice(adder.unitPrice, adder.quantity)));
  }, [getAdderPrice, proposalAdders]);

  if (proposalAdders.length === 0) {
    return null;
  }

  return (
    <OrderBlock hideValue={isPriceHidden} title="Adders" value={addersTotal}>
      <br />
      {proposalAdders.map((adder: AdderVm, key: number) => (
        <div key={adder.name + key}>
          <OrderBlockWrapper color="#FAFAFA">
            <div className={styles.adder_wrapper}>
              <div className={styles.adder_item}>{adder.name}</div>
              {!isPriceHidden && (
                <div className={styles.adder_item}>
                  {formatPriceWithCurrency(getAdderPrice(adder.unitPrice, adder.quantity))}
                </div>
              )}
            </div>
          </OrderBlockWrapper>
          <br />
        </div>
      ))}
      <br />
    </OrderBlock>
  );
};
